import DeviceImportCard from './DeviceImportCard'

export default DeviceImportCard
